module.exports = __webpack_public_path__ + "static/02-436eb8c8a9354bec14ade3f5a7deb09d.jpg";